app.service('productTabQuestion',function(console, answer, question, comment, notice, loading, validate, modal, login) {
	var $self;
	/*
	questions:{

		init:function(hash){
			
			if($.cookie('question'+mobile.product.id)){
				questionFormSubmitSuccess();
			}
			$('.question').each(function(){
				answerFormSubmitSuccess($(this).attr('id').substr(9));
			});
		},
	},
	 */
	function goToCommentCallback(json){
		var element='#comment-'+json.comment.token;
		$.scrollTo(element);
		if(json.action){
			tokenAction('comment',json.action,json.token);
		}
	}
	function goToAnswerCallback(json){
		var element='#answer-'+json.answer.token;
		if(element.length)$.scrollTo(element);
		if(json.comment){
			comment.load({
				answerToken:json.answer.token,
				pageNr:json.comment.pageNumber,
				singlePage:false
			},{
				callback:function(){
					goToCommentCallback(json);
				}
			});
		}else{
			if(json.action){
				tokenAction('answer',json.action,json.token);
			}
		}
	}
	function goToQuestionCallback(json){
		var element='#question-'+json.question.token;
		$.scrollTo(element);
		if(json.answer){
			answer.load({
				questionToken:json.question.token,
				pageNr:json.answer.pageNumber,
				singlePage:false
			},{
				callback:function(){
					goToAnswerCallback(json);
				}
			});
		}else{
			if(json.action){
				tokenAction('question',json.action,json.token);
			}
		}
	}
	function goToTokenSuccess(json){
		loading.stop();
		if(json.question){
			$('#question-'+json.token).remove();
			question.load({
				pageNr:json.question.pageNumber
			},{
				callback:function(){
					goToQuestionCallback(json);
				}
			});
		}else{
			mobile.alert('Nie znaleziono odpowiedzi lub nie została jeszcze zweryfikowana.');
		}
	}
	function goToToken(hash){
		if(hash=='dodaj'){
			tokenAction('new');
		}else{
			var list=decodeURI(hash).split('|');
			var action=(list[1] && list[1]!=='')?list[1]:false;
			var type=list[0].substr(0,1);
			var token=list[0].substr(1);
			var sort=$('.questions-order').val();
			
			var data={
				sort:(sort?sort:undefined),
				answerToken: (type=='a'?token:undefined),
				questionToken: (type=='q'?token:undefined),
				commentToken: (type=='c')?token:undefined
			};

			if(type=='a' || type=='q' || type=='c'){
				loading.start();
				$.ajax({
					url:'/front-page-with-utterance.ltr',
					data:data,
					success:function(json){
						loading.stop();
						goToTokenSuccess($.extend(true,json,{
							action : action,
							type : type,
							token : token
						}));
					},
					error:function(){
						loading.stop();
						mobile.alert('Wystąpił błąd. Prosimy spróbować później');
					}
				});
			}
		}
	}
	
	function tokenAction(type,action,token){
		switch (type) {
			case 'question':
				if(action=='dodaj'){
					answer.loadForm(token);
				}
				break;
			case 'answer':
				if(action=='dodaj'){
					comment.loadForm(token);
				}else if(action=='plus'){
					answer.vote(true, token);
				}else if(action=='minus'){
					answer.vote(false, token);
				}
				break;
			case 'new':
				question.loadForm();
				break;
			default:
				break;
		}
	}
	function setEvents(){
		//pytania
		$self.on('change','.js-questions-order',function(){
			question.changeOrder();
			UA.pageInteraction('Pytania i Odpowiedzi', 'Filtrowanie - ' + $(this).val());
		});
		$self.on('click','.js-more-load-questions',function(){
			question.changePage($(this).data('page'));
		});
		$self.on('click','.js-load-question-form',function(){
			$self.addClass('show-question-form');
			question.loadForm();
			UA.pageInteraction('Pytania i Odpowiedzi', 'Zadaj pytanie');
		});
		$self.on('click','.js-hide-question-form',function(){
			$self.removeClass('show-question-form');
			return false;
		});
		//powiadomienia
		$self.on('click', '.js-let-me', function(){
			notice.letMe();
		});
		
		//odpowiedzi
		
		$self.on('click','.js-load-only-answer-form',function(){
			answer.loadForm($(this).data('question'),true);
		});
		$self.on('click','.js-load-answer-form',function(){
			answer.load({questionToken:$(this).data('question')});
			answer.loadForm($(this).data('question'),true);
		});
		$self.on('click','.js-load-answers',function(){
            answer.load({
                questionToken: $(this).data('question'),
                fromVariant: $(this).data('from-variant')
            });
			answer.loadForm($(this).data('question'),false);
			UA.pageInteraction('Pytania i Odpowiedzi', 'Rozwiń odpowiedzi');
		});
		$self.on('click','.js-more-load-answers',function(){
			answer.load({
				questionToken:$(this).data('question'),
				pageNr:$(this).data('page')
			});
		});
		$self.on('click','.js-hide-answers',function(){
			answer.hide($(this).data('question'));
		});
		$self.on('click','.js-hide-answer-form', function(event){
			answer.hideFormAction($(this).closest('form'));
		});
		$self.on('click','.answer-form textarea',function(){
			answer.showFormAction($(this).closest('form'));
		});
		$self.on('click','.js-measure-positive',function(){
			answer.vote(true,$(this).data('answer'));
		});
		$self.on('click','.js-measure-negative',function(){
			answer.vote(false,$(this).data('answer'));
		});
		
		
		
		//komentarze
		$self.on('click','.js-load-only-comment-form',function(){
			comment.loadForm($(this).data('answer'),true);
		});
		$self.on('click','.js-load-comment-form',function(){
			comment.loadForm($(this).data('answer'),true);
			comment.load({answerToken:$(this).data('answer')});
		});
		$self.on('click','.js-load-comments',function(){
			comment.loadForm($(this).data('answer'),false);
			comment.load({answerToken:$(this).data('answer')});
		});
		$self.on('click','.js-more-load-comments',function(){
			comment.load({answerToken:$(this).data('answer'),pageNr:$(this).data('page')});
		});
		$self.on('click','.js-hide-comments',function(){
			comment.hide($(this).data('answer'));
		});
		$self.on('click','.comment-form textarea',function(){
			comment.showFormAction($(this).closest('form'));
		});
		
		question.addInfo();
		
		$('.questions-list .question-item').each(function(){
			answer.addInfo($(this).attr('id').substr(9));
		});
	}
	function setElements(){
		$self=$('#questions');
	}
	function init(){
		setElements();
		setEvents();
	}
	return {
		init:init,
		goToToken:goToToken
	};
});